import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClientTransaction, ClientTransactionAndAnswerView, ClientTransactionView, TrnsPageView } from '../models/products/transactions';
import { Product } from '../models/products/products';
import { EVENT_TYPES, GaAnalyticsService } from './ga-analytics.service';
import { AppSetting } from '../global/appsetting';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransactionsService {
  clientTransactionsView$ = new BehaviorSubject<ClientTransactionView[]>([]);

  fileList = { data: { items: [] } };

  progressBarValue = 0;
  intervalTime = 100;

  constructor(private _http: HttpClient, 
    private _appSetting: AppSetting,
    private _gaAnalyticsService: GaAnalyticsService
    ) {
    if ((<any>localStorage).clientTransactionsView != null && (<any>localStorage).clientTransactionsView !== 'undefined') {
      this.clientTransactionsView$.next(JSON.parse((<any>localStorage).clientTransactionsView));
    }
   }

   saveClientTransactionToLocalStorage(): void {
    (<any>localStorage).clientTransactionsView = JSON.stringify(this.clientTransactionsView$.getValue());
    const filesArrayReprest = [];
    this.fileList.data.items.forEach(x => {
      filesArrayReprest.push([]);
      if(x && x.length>0){
        x.forEach(file => {
          filesArrayReprest[filesArrayReprest.length - 1].push(file.name);
        });
      }
    });
    (<any>localStorage).fileListArr = JSON.stringify(filesArrayReprest);
  }


  InsertTransaction(clientTransactionView: ClientTransactionView): Observable<number> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (clientTransactionView.CouponId == null) {
      clientTransactionView.CouponId = 0;
    }
    return this._http.post<number>(this._appSetting.siteUrl + 'api/product/transaction', clientTransactionView, { headers: headers });
  }

  InsertTransactions(clientTransactionAndAnswerView: ClientTransactionAndAnswerView): Observable<string>  {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (clientTransactionAndAnswerView.CouponId == null) {
      clientTransactionAndAnswerView.CouponId = 0;
    }
    return this._http.post<string>(this._appSetting.siteUrl + 'api/product/transactions', clientTransactionAndAnswerView, { headers: headers });

  }

  SendTransactionMailBeforePay(UniqIdForPay: string, fileList: Array<any>): Observable<HttpEvent<string>> {
    const formData: FormData = new FormData();
    if (fileList != null) {
      for (let j = 0; j < fileList.length; j++) {
        for (let i = 0; i < fileList[j].length; i++) {
          formData.append('files', fileList[j][i], (j + 1) + '.' + fileList[j][i].name);
        }

      }
    }

    const headers = new HttpHeaders({ 'UniqIdForPay': UniqIdForPay });
    const req = new HttpRequest('POST', this._appSetting.siteUrl + 'api/product/SendTranscationMailBeforePay',
      formData, { headers: headers });
    return this._http.request<string>(req);
  }

  SendTransactionMailBeforePayWithOutFiles(clientTransactionView: ClientTransactionView, error): Observable<string> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this._http.post<string>(this._appSetting.siteUrl + 'api/product/SendTranscationMailBeforePayWithOutFiles',
      {clientTransactionView, error}, { headers: headers });
  }


  OrderAllProducts(productList: Array<Product>, captchaResponse: string, pass: string): Observable<boolean> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this._http.put<boolean>(this._appSetting.siteUrl + 'api/product/order-products', { productList, captchaResponse, pass }, { headers });
  }

  GetTransactionsPage(trnsPageView: TrnsPageView): Observable<any> {
    return this._http.get<any>(this._appSetting.siteUrl + `api/product/transactions/${trnsPageView.id}/${trnsPageView.isActive}/${trnsPageView.numOfTrns}`,{ headers: new HttpHeaders({'token': trnsPageView.token})} );
  }

  GetAllTransactionsIds(isActive: boolean, token: string) {
    return this._http.get(this._appSetting.siteUrl + 'api/product/transactions/ids/' + isActive, { headers: new HttpHeaders({
      'token': token
    })}).toPromise().then(res=>{
      return res;
    }).catch(err=>{
      this._gaAnalyticsService.logEventToGa('GetAllTrnsactionsIds', 'ProductsService', EVENT_TYPES.Error);
    })
   
  }

  EditMultipleTransactions(listOfTransactions: Array<ClientTransaction>, token) {
    return fetch(this._appSetting.siteUrl + 'api/product/EditMultipleTransactions', {
      method: 'POST',
      body: JSON.stringify(listOfTransactions),
      headers: {
        'Content-Type': 'application/json',
        'token': token
      }
    }).then(res => {
      if (res) {
        return res.json();
      } else {
        return null;
      }
    }).catch(err => {
      this._gaAnalyticsService.logEventToGa('EditMultipleTransactions', 'ProductsService', EVENT_TYPES.Error);
    });
  }

  DeactivateAllTransactions(token) {
    return fetch(this._appSetting.siteUrl + 'api/product/DeactivateAllTransactions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'token': token
      }
    }).then(res => {
      if (res) {
        return res.json();
      } else {
        return null;
      }
    }).catch(err => {
      this._gaAnalyticsService.logEventToGa('deactivateAllTransactions', 'ProductsService', EVENT_TYPES.Error);
    });
  }

  GetTransactionsByToken(token: string): Observable<void> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const params = new HttpParams().append('token', token);
    return this._http.post<void>(this._appSetting.siteUrl + 'api/product/GetTransactionsByToken', { headers: headers }, { params: params });
  }

  SendAlertToUserAndAdmin(token: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const params = new HttpParams().append('UniqIdForPay', token);
    return this._http.post(this._appSetting.siteUrl + 'api/product/SendAlertToUserAndAdmin', { headers: headers }, { params: params });
  }

  SendSuccussTransaction(token: string): Observable<boolean> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const params = new HttpParams().append('UniqIdForPay', token);
    return this._http.post<boolean>(this._appSetting.siteUrl + 'api/product/SendSuccussTransaction', { headers: headers }, { params: params });
  }

  getNumberOfTrans(isActive: boolean): Observable<number> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this._http.get<number>(this._appSetting.siteUrl + 'api/product/trans-number/'+ isActive, { headers: headers });
  }

  animateProgressBar(): void {
    this.intervalTime = 0;
    if (this.fileList.data.items.length > 0) {
      this.fileList.data.items.forEach(files => {
        files.forEach(file => {
          this.intervalTime += file.size / 25000;
        });

      });
    } else {
      this.intervalTime = 100;
    }
    const interval = setInterval(() => {
      if (this.progressBarValue < 100) {
        this.progressBarValue++;
      } else {
        clearInterval(interval);
      }
    }, this.intervalTime);
  }
  
}
